var React = require('react');

function IcShareXCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM13.7949 15.7227L8 22H9.30469L14.377 16.5029L18.4756 22H22.9131L16.832 13.8438L22.2246 8H20.9219L16.25 13.0615L12.4766 8H8.03613L13.7949 15.7227ZM20.9971 21.0352H18.957L9.95508 8.96191H11.9941L20.9971 21.0352Z","fill":"currentColor"}));
}

IcShareXCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"currentColor"};

module.exports = IcShareXCircle;

IcShareXCircle.default = IcShareXCircle;
